import React from 'react';
import Typography from '@mui/material/Typography';

/**
 * OpenAssignmentDisplay - Displays open assignment information in a highlighted box
 * @param {Array} openAssignments - Array of open assignment objects
 */
export default function OpenAssignmentDisplay({ openAssignments = [] }) {
  if (!openAssignments || openAssignments.length === 0) {
    return null;
  }

  return (
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
      <strong>Assignment:</strong> {openAssignments[0].description}
    </Typography>
  );
}
